import { render } from "./PopUp.vue?vue&type=template&id=42fbcdda&scoped=true"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=42fbcdda&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42fbcdda"

export default script